import '../pages.css';
import { Link } from 'react-router-dom';

const BruxZir = () => {
    return (
        <div className="page product-detail">
            {/* Hero Section */}
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>BruxZir®</h1>
                    <p className="product-tagline">Exceptional strength with improved esthetics</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="product-detail-content">
                <div className="content-container">
                    {/* Description */}
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            BruxZir® restorations from <strong>AbELab</strong> combine exceptional strength with improved esthetics
                            compared to traditional PFM or full-cast options. A highly durable zirconia core is enhanced with layered
                            porcelain, delivering both longevity and natural appearance. The translucent zirconia substructure eliminates
                            the dark margins and gingival discoloration commonly associated with metal-based restorations.
                        </p>
                    </div>

                    {/* Two Column Layout */}
                    <div className="product-two-column">
                        {/* Indications */}
                        <div className="product-section">
                            <h2>Indications</h2>
                            <p>BruxZir zirconia is extremely versatile and suitable for:</p>
                            <ul>
                                <li>Single crowns</li>
                                <li>Bridges with various abutment and pontic combinations</li>
                                <li>Inlay bridges</li>
                                <li>Maryland-type bridges</li>
                                <li>Screw-retained implant restorations</li>
                            </ul>
                            <p>It also serves as an esthetic alternative to PFM restorations in cases with limited occlusal space.</p>
                        </div>

                        {/* Contraindications */}
                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>Situations requiring the highest level of esthetic matching to adjacent natural teeth or existing restorations</li>
                                <li>Cases where strong and predictable bonding is critical, as bond strength is less reliable compared to other ceramic systems</li>
                            </ul>
                        </div>
                    </div>

                    {/* Preparation */}
                    <div className="product-section">
                        <h2>Preparation</h2>
                        <ul>
                            <li>Shoulder preparation is not required</li>
                            <li>Mild chamfer or feather-edge margins are recommended</li>
                            <li>Ideal reduction: 1 mm buccal, lingual, and occlusal</li>
                            <li>Minimum reduction: 0.5 mm where space is limited</li>
                            <li>Minimum occlusal reduction: 0.5 mm (1 mm preferred)</li>
                        </ul>

                        <h3>Adjustments & Polishing</h3>
                        <p>Use fine-grit diamond burs with water and air spray to prevent overheating and microfractures.</p>
                        <ul>
                            <li>Football-shaped bur: occlusal and lingual surfaces</li>
                            <li>Tapered bur: buccal and lingual surfaces</li>
                            <li>Polish with a porcelain polishing system of choice</li>
                        </ul>
                    </div>

                    {/* Cementation */}
                    <div className="product-section">
                        <h2>Cementation</h2>
                        <ul>
                            <li>Resin-reinforced glass ionomer (e.g., RelyX™ Luting)</li>
                            <li>Resin cement (e.g., RelyX™ Unicem or RelyX™ Ultimate) when retention is limited</li>
                        </ul>
                        <p>Before cementation, clean the internal surface with <strong>Ivoclean</strong> to ensure optimal bond strength.</p>
                    </div>

                    {/* Technical Notes */}
                    <div className="product-section">
                        <h2>Technical Notes</h2>
                        <p>Solid zirconia requires a preparation similar to cast gold.</p>
                        <p>Use zirconia-specific diamonds and rubber polishers with diamond paste for adjustments.</p>
                    </div>

                    {/* Codes */}
                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2740</strong> – Crown, porcelain/ceramic substrate</li>
                            <li><strong>D6245</strong> – Pontic, porcelain/ceramic</li>
                            <li><strong>D6740</strong> – Abutment crown, porcelain/ceramic</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BruxZir;
